<template>
  <div id="login">
    <!-- <div class="center-xs container"> -->
    <div class="info-container">
      <transition-group
        name="left-info"
        tag="main"
        type="animation"
        mode="out-in"
        appear
        @before-enter="beforeEnter"
        @enter="enter"
      >
        <p key="title" id="title">Bem vindo de volta!</p>
        <h1 key="subtitle" id="subtitle">
          Sistema Integrado de Gestão e Manejo Agrícola
        </h1>
      </transition-group>

      <img :src="logoBackground" alt="" class="img-background" />
    </div>
    <div class="container-form">
      <div class="login-details">
        <div class="login-logo">
          <img :src="logo" width="100%" />
        </div>
        <div class="login-form">
          <b-form novalidate ref="loginForm" @keyup.enter="submitLogin">
            <b-form-input
              v-model.trim="login.user"
              placeholder="Usuário"
              aria-describedby="userLoginInputLiveFeedback"
              class="userLoginInput"
            >
            </b-form-input>
            <p />
            <b-form-input
              v-model.trim="login.psw"
              placeholder="Senha"
              aria-describedby="pwdInputLiveFeedback"
              type="password"
              class="passwordLoginInput"
            >
            </b-form-input>
            <p />
            <b-btn
              :variant="reqLogin ? 'dark' : '3v3'"
              @click="submitLogin"
              block
              :disabled="reqLogin"
              >ENTRAR</b-btn
            >
            <div class="error-msg">{{ errorMsg }}</div>
          </b-form>
        </div>
        <div class="login-local">
          <div>
            <div v-if="hasAssociatedFarms">
              <b-dropdown :text="local">
                <b-dropdown-item href="#">
                  {{ local }}
                </b-dropdown-item>

                <b-dropdown-item
                  v-for="farm in farmsAssociateds"
                  :key="farm.URL"
                  :href="farm.URL"
                >
                  {{ farm.NAME.toUpperCase() }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <div v-else>
              <map-marker-icon title="" />
              <span class="local-name">{{ local }}</span>
            </div>
          </div>

          <span :class="{ 'mt-2': hasAssociatedFarms }">
            {{ city }} - {{ state }}
          </span>
        </div>
        <div class="app-version">v{{ appVersion }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import crypto from "crypto-browserify";
import { session } from "@/api";
import { user } from "@/pages/components/globalstore";
import store from "@/store";
import appVersion from "@/version";
export default {
  name: "login",
  props: {
    local: [String],
    city: [String],
    state: [String],
  },
  computed: {
    hasAssociatedFarms() {
      return this.farmsAssociateds && this.farmsAssociateds.length;
    },
  },
  async created() {
    this.farmsAssociateds = await session.getFarmsAssociated();
    this.$emit("title-change", "");
  },
  data() {
    return {
      user,
      appVersion,
      reqLogin: false,
      farmsAssociateds: null,
      logo: require("../assets/icons/3v3.svg"),
      size: null,
      login: {
        user: "",
        psw: "",
      },
      errorMsg: "",
      loginState: true,
      pwdState: true,
      showPwd: false,
      has_management_access: false,
      has_alerts_access: false,
      logoBackground: require("../assets/icons/login-3v3.svg"),
    };
  },
  methods: {
    submitLogin() {
      this.errorMsg = "";
      if (this.login.user != "" && this.login.psw != "") {
        let PSW = crypto.createHash("md5").update(this.login.psw).digest("hex");
        this.reqLogin = true;
        session
          .validate({
            LOGIN: this.login.user,
            PSW,
          })
          .then((ret) => {
            if (ret.status) {
              //Mock - login when ADD_ONS not exists
              // ret.value.ADD_ONS_ACCESS = {
              //   MANAGEMENT: true,
              //   ALERTS: true,
              // };
              store.commit("setAddonsAccess", ret.value.ADD_ONS_ACCESS);
              store.commit("setUserData", ret.value);

              user.doLogin(ret.value);
              this.$emit("change-active-user");
              setTimeout((_) => (window.location.href = "#/monitoring"), 1200);
            } else {
              this.errorMsg = ret.log;
              this.reqLogin = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.reqLogin = false;
            this.errorMsg = "Não foi possível realizar o login";
          });
      } else this.errorMsg = "Ambos os campos devem ser preenchidos";
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      let count = 0;
      let draw = (id) => {
        let count = 0;
        const timeout = setInterval(() => {
          if (el.id === id) {
            el.style.opacity = count;
          }
          count += 0.1;
          if (count >= 1) {
            clearInterval(timeout);
            count = 1;
            done();
            return;
          }
        }, 80);
      };
      const timeout = setInterval(() => {
        if (el.id === "title") {
          el.style.opacity = count;
        }
        count += 0.1;
        if (count >= 1) {
          clearInterval(timeout);
          count = 1;
          draw("subtitle", done);
        }
      }, 80);
    },
  },
};
</script>

<style scoped>
::-webkit-input-placeholder {
  /* Edge */
  color: #cccccc;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cccccc;
}
::placeholder {
  color: #7c7c7c;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 50px #082e31 inset; /* Change the color to your own background color */
  -webkit-text-fill-color: #d0d0d0;
}
input:-webkit-autofill:focus {
  -webkit-text-fill-color: #d0d0d0;
}
.login-logo {
  max-width: 100%;
  text-align: center;
}
.login-logo img {
  max-width: 70%;
}
.userLoginInput {
  background-color: #082e31 !important;
  border-color: #26575a;
  color: #d0d0d0;
}
.passwordLoginInput {
  background-color: #082e31 !important;
  border-color: #26575a;
  color: #d0d0d0;
}
.title {
  opacity: 0;
}
.subtitle {
  opacity: 0;
}
#login {
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: #133c3f;
  overflow: hidden;
  color: #d0d0d0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container-form {
  height: 100%;
  width: 45%;
  display: flex;
  background-color: #1f3b3d;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
.login-details {
  max-width: 222px;
  -webkit-animation: fadein 4s;
  -moz-animation: fadein 4s;
  -ms-animation: fadein 4s;
  -o-animation: fadein 4s;
  animation: fadein 4s;
}
.login-local {
  margin-top: 37px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login-details .login-local span {
  font-size: 0.65em;
}
.login-details .login-local .material-design-icon {
  font-size: 1.1em;
}
.app-version {
  margin-top: 12px;
  font-size: 0.7em;
  text-align: center;
  opacity: 0.5;
}
.login-form {
  width: 230px;
  height: 190px;
  padding-top: 35px;
  -webkit-animation: fadein 6s;
  -moz-animation: fadein 6s;
  -ms-animation: fadein 6s;
  -o-animation: fadein 6s;
  animation: fadein 6s;
}
.login-form form input {
}
.local-name {
  font-size: 20px !important;
}
.login-box {
  width: 300px;
  height: 420px;
  z-index: 10000;
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -150px;
  margin-top: -150px;
  padding: 15px;
}
.margin-top {
  margin-top: 40px;
}
.error-msg {
  margin-top: 4px;
  font-size: 0.85em;
  color: #ff6170;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media screen and (max-width: 768px) {
  .info-container {
    display: none;
  }
  #login {
    overflow: hidden;
    top: 0;
    left: 0;
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container-form {
    height: 100%;
    width: 100%;
    display: flex;
    background-color: #1f3b3d;
    justify-content: center;
    align-items: center;
  }
  .login-form {
    top: 154px;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
